export const UserKey = 'USER_INFO'
export const TokenKey = 'USER_TOKEN'
export const AuthKey = 'USER_AUTH'
export const AgentKey = 'AGENT_INFO'
export const LicenceKey = 'LICENCE_KEY'
export const TermsKey = 'TERMS_KEY'


// WEBPACK FOOTER //
// ./src/utils/cookies/keys.js